module.exports = __webpack_public_path__ + "assets/images/restaurant-04.8e1b723a524661631a01b05ed710e44a.svg";